import firebase from 'firebase/compat/app';

const firebaseConfig = {
    //add firebase credetials here
};
// Initialize Firebase
// firebase.initializeApp(firebaseConfig);

export default firebase;